import React from 'react';

import {LeafType, isBenchlingTypeDefList} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {EntrySearchInputWithItems} from 'notebook/entries/EntrySearchInput';

import {ValueInputProps} from './ValueInputTypes';
import valuesToItemsArray, {itemsToValuesArray} from './valuesToItemsArray';

/**
 * @package
 */
export default function EntryValueInput({
  onChange,
  typeDef,
  valueInput,
  disabled,
}: ValueInputProps<LeafType.ENTRY>): JSX.Element {
  const value = valueInput.isValid ? valueInput.value : null;

  return (
    <EntrySearchInputWithItems
      shouldAllowMultiple={isBenchlingTypeDefList(typeDef)}
      onChange={(items) => {
        const itemIds = itemsToValuesArray(items);

        if (isBenchlingTypeDefList(typeDef)) {
          onChange(itemIds);
        } else {
          onChange(itemIds[0] ?? null);
        }
      }}
      selectedItems={valuesToItemsArray(value)}
      disabled={disabled}
      isReadOnly={disabled}
    />
  );
}
